import { CreateTripItemRequest } from 'tripPlanner/api/tripItem/types'
import { TripItem } from 'tripPlanner/types/tripItem'
import {
  assertUnreachable,
  nullifyBookedDetails,
  nullifyEndDates,
  nullifyStartDates,
} from 'tripPlanner/utils'

export function itemToCuratedItemPayload(
  tripItem: TripItem,
): CreateTripItemRequest {
  const {
    id: templateItemId,
    tripId: templateId,
    createdBy,
    updatedBy,
    createdAt,
    updatedAt,
    userUpdatedAt,
    sortableName,
    ...item
  } = tripItem

  switch (item.type) {
    case 'AIRBNB':
    case 'EVENT':
      if (item.place.type === 'GEO') {
        return {
          ...item,
          place: {
            ...item.place,
            type: 'GEO_MULTI_DATES',
            ...nullifyStartDates(),
            ...nullifyEndDates(),
          },
          ...nullifyStartDates(),
          ...nullifyEndDates(),
          ...nullifyBookedDetails(),
          templateId,
          templateItemId,
        }
      }

      return {
        ...item,
        place: {
          ...item.place,
          type: 'CUSTOM_MULTI_DATES',
          ...nullifyStartDates(),
          ...nullifyEndDates(),
        },
        ...nullifyStartDates(),
        ...nullifyEndDates(),
        ...nullifyBookedDetails(),
        templateId,
        templateItemId,
      }

    case 'EXPERIENCE':
      // TODO: we'll be able to remove this once the backend is no longer returning these types
      if (item.place.type === 'GEO') {
        return {
          ...item,
          place: {
            ...item.place,
            type: 'GEO_MULTI_DATES',
            ...nullifyStartDates(),
            ...nullifyEndDates(),
          },
          ...nullifyStartDates(),
          ...nullifyEndDates(),
          ...nullifyBookedDetails(),
          templateId,
          templateItemId,
        }
      }

      return {
        ...item,
        place: {
          ...item.place,
          type: 'CUSTOM_MULTI_DATES',
          ...nullifyStartDates(),
          ...nullifyEndDates(),
        },
        ...nullifyStartDates(),
        ...nullifyEndDates(),
        ...nullifyBookedDetails(),
        templateId,
        templateItemId,
      }
    case 'HOTEL':
    case 'ACCOMMODATION_RENTAL':
      // TODO: we'll be able to remove this once the backend is no longer returning these types
      if (item.place.type === 'GEO') {
        return {
          ...item,
          place: {
            ...item.place,
            type: 'GEO_MULTI_DATES',
            ...nullifyStartDates(),
            ...nullifyEndDates(),
          },
          ...nullifyStartDates(),
          ...nullifyEndDates(),
          ...nullifyBookedDetails(),
          templateId,
          templateItemId,
        }
      }
      return {
        ...item,
        place: {
          ...item.place,
          type: 'CUSTOM_MULTI_DATES',
          ...nullifyStartDates(),
          ...nullifyEndDates(),
        },
        ...nullifyStartDates(),
        ...nullifyEndDates(),
        ...nullifyBookedDetails(),
        templateId,
        templateItemId,
      }
    case 'RESTAURANT_BAR':
    case 'ATTRACTION':
      return {
        ...item,
        place: {
          ...item.place,
          ...nullifyStartDates(),
        },
        ...nullifyStartDates(),
        ...nullifyBookedDetails(),
        templateId,
        templateItemId,
      }
    case 'BUS':
    case 'FERRY':
    case 'OTHER_TRANSPORT':
    case 'TRAIN':
    case 'ACTIVITY':
    case 'THING_TO_DO':
      return {
        ...item,
        startPlace: {
          ...item.startPlace,
          ...nullifyStartDates(),
        },
        endPlace: {
          ...item.endPlace,
          ...nullifyStartDates(),
        },
        ...nullifyStartDates(),
        ...nullifyEndDates(),
        ...nullifyBookedDetails(),
        startTimezone: item.startTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
        endTimezone: item.endTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
        templateId,
        templateItemId,
      }
    case 'FLIGHT':
      return {
        ...item,
        startPlace: {
          ...item.startPlace,
          ...nullifyStartDates(),
        },
        endPlace: {
          ...item.endPlace,
          ...nullifyStartDates(),
        },
        ...nullifyStartDates(),
        ...nullifyEndDates(),
        ...nullifyBookedDetails(),
        startTimezone: item.startTimezone,
        endTimezone: item.endTimezone,
        templateId,
        templateItemId,
      }
    case 'CAR_RENTAL':
    case 'CRUISE':
      return {
        ...item,
        startPlace: {
          ...item.startPlace,
          ...nullifyStartDates(),
        },
        endPlace: item.endPlace
          ? {
              ...item.endPlace,
              ...nullifyStartDates(),
            }
          : undefined,
        ...nullifyStartDates(),
        ...nullifyEndDates(),
        ...nullifyBookedDetails(),
        startTimezone: item.startTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
        endTimezone: item.endTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
        templateId,
        templateItemId,
      }
    case 'TOUR':
      return {
        ...item,
        startPlace: {
          ...item.startPlace,

          ...nullifyStartDates(),
        },
        endPlace: item.endPlace
          ? {
              ...item.endPlace,
              ...nullifyStartDates(),
            }
          : undefined,
        ...nullifyStartDates(),
        ...nullifyEndDates(),
        ...nullifyBookedDetails(),
        startTimezone: item.startTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
        endTimezone: item.endTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
        templateId,
        templateItemId,
      }
    case 'NOTE':
      return {
        ...item,
        ...nullifyStartDates(),
        ...nullifyEndDates(),
        ...nullifyBookedDetails(),
        isSectionHeader: !!item.isSectionHeader,
        templateId,
        templateItemId,
      }
    default:
      return assertUnreachable(item)
  }
}
